import Vue from 'vue';
import Router from 'vue-router';
import Top from './components/pages/Top.vue';
import Owner from './components/pages/Owner.vue';
import Detail from './components/pages/Detail.vue';
import Upload from './components/pages/Upload.vue';
import Histories from './components/pages/Histories.vue';
import UploadFast from './components/pages/UploadFast.vue';
/*
import Term from './components/pages/Term.vue';
import PrivacyPolicy from './components/pages/PrivacyPolicy.vue';
import Contact from './components/pages/Contact.vue';
*/
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top,
    },
    {
      path: '/owner/:address',
      name: 'Owner',
      component: Owner,
      props: true,
    },
    {
      path: '/detail/:txHash',
      name: 'Detail',
      component: Detail,
      props: true,
    },
    {
      path: '/upload',
      name: 'Upload',
      component: Upload,
    },/*
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },*/
    {
      path: '/histories',
      name: 'Histories',
      component: Histories,
    },
    /*
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/term',
      name: 'Term',
      component: Term,
    },*/
    {
      path: '/upload-fast',
      name: 'UploadFast',
      component: UploadFast,
    },
    {
      path: '/upload-fast/:txhash',
      name: 'UploadFast',
      component: UploadFast,
      props: true,
    },
  ],
});
